import React from 'react'
import { ruleIconClassName } from 'modules/automation-rules/constants/automation-rule-icon-class'
import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import {
  AddTagIcon,
  BookingIcon,
  CampaignCompleteIcon,
  CommunityIcon,
  CourseCompletedIcon,
  CourseIcon,
  EmailLinkClickedIcon,
  EmailOpenedIcon,
  FormSubscribedIcon,
  LectureCompletedIcon,
  ModuleCompletedIcon,
  NewSaleIcon,
  PageVisitedIcon,
  RemoveTagIcon,
  SaleCanceledIcon,
  SubscriptionPaymentFailedIcon,
  WebinarIcon,
} from '@systemeio/ui/icons'

export const getTriggerIcon = (trigger: AutomationRuleTriggersEnum): React.JSX.Element => {
  switch (trigger) {
    case AutomationRuleTriggersEnum.tag_added:
      return <AddTagIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.tag_removed:
      return <RemoveTagIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.registered_to_webinar:
      return <WebinarIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.enrolled_in_course:
    case AutomationRuleTriggersEnum.enrolled_in_course_bundle:
      return <CourseIcon className={`fill-fill-primary ${ruleIconClassName}`} />
    case AutomationRuleTriggersEnum.course_completed:
      return <CourseCompletedIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.module_completed:
      return <ModuleCompletedIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.lecture_completed:
      return <LectureCompletedIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.form_subscribed:
    case AutomationRuleTriggersEnum.blog_page_form_subscribed:
    case AutomationRuleTriggersEnum.website_form_subscribed:
      return <FormSubscribedIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.campaign_completed:
      return <CampaignCompleteIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.new_sale:
      return <NewSaleIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.sale_canceled:
      return <SaleCanceledIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.email_link_clicked:
      return <EmailLinkClickedIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.email_opened:
      return <EmailOpenedIcon className={`${ruleIconClassName} fill-fill-primary`} />
    case AutomationRuleTriggersEnum.page_visited:
      return <PageVisitedIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.enrolled_in_community:
      return <CommunityIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.subscription_payment_failed:
      return <SubscriptionPaymentFailedIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.digital_store_form_subscribed:
      return <FormSubscribedIcon className={ruleIconClassName} />
    case AutomationRuleTriggersEnum.booking_created:
      return <BookingIcon className={ruleIconClassName} />
  }
}
